//#region Angular Imports

import { StateService } from '@uirouter/angularjs'

//#endregion

//#region DevExtreme Imports

import DevExpress from 'devextreme'

//#endregion

import { EventsNames } from '../../../helpers/events-names'
import { UserModel } from '../../api/api.models'

import { Api } from '../../api/api.module'
import { CommonHelper } from '../../../helpers/common-helper'

import { IUserSession } from '../../../helpers/user-session'

import { OpOperator } from '../../../models/core/op-operator'
import { MenuItem } from '../sidebar-menu/common.sidebar-menu.directive';

//#region Asset Imports

import './header.scss'
import * as TEMPLATE from './header.tpl.html'

//#endregion

interface HeaderScope extends ng.IScope {
    user: UserModel
    //activities: Dictionary<boolean>
    loggedOperator: OpOperator
    openUserDetails(): void
    logoutIcon: string
    distributorsIcon: string
    userIcon: string
    alarmIcon: string

    userMenuOptions: any
    alarmsMenuOptions: any

    myAccountButtonOptions: DevExpress.ui.dxButtonOptions
    signOutButtonOptions: DevExpress.ui.dxButtonOptions

    shouldRefresh: boolean

    logout(): void
}

export class HeaderDirective implements ng.IDirective {

    restrict = 'E'

    controller = ['$scope', '$interval', '$state', '$timeout', 'api', 'userSession', ($scope: HeaderScope, $interval: ng.IIntervalService, $state: StateService, $timeout: ng.ITimeoutService, api: Api, userSesssion: IUserSession) => {
        $scope.user = api.login.getUser();

        $scope.loggedOperator = userSesssion.getLoggedOperator()

        $scope.logoutIcon = window['config']['ICONS']['LOGOUT']
        $scope.userIcon = window['config']['ICONS']['USER']
        $scope.distributorsIcon = window['config']['ICONS']['DISTRIBUTORS']
        $scope.alarmIcon = window['config']['ICONS']['ALARMS']
        $scope['dashboardEditIcon'] = window['config']['ICONS']['DASHBOARD_EDIT']
        $scope.shouldRefresh = true

        var alarmIconRefresh = () => {
            if ($scope.alarmIcon == window['config']['ICONS']['ALARMS'] && $scope.$root['alarmsCount'] > 0) $scope.alarmIcon = window['config']['ICONS']['ALARMS_ACTIVE']
            else $scope.alarmIcon = window['config']['ICONS']['ALARMS']
        }

        $interval(() => {
            alarmIconRefresh()
        }, 500)

        $scope.$on(EventsNames.ALARM_APPROVED, (event: ng.IAngularEvent, ...args: any[]) => {
            let approvedAlarmsCount = args[0]
            //$scope.$root['alarmsCount'] = $scope.$root['alarmsCount'] - approvedAlarmsCount

            $scope.$root.$broadcast(EventsNames.REFRESH_ALARMS)
            alarmIconRefresh()
        })


        if ($scope.user) {
            $scope.userMenuOptions = {
                target: '.menu-button',
                popoverVisible: false
            }
            $scope.alarmsMenuOptions = {
                popoverVisible: false
            }
        }

        $scope.logout = () => {
            CommonHelper.logoutFromApp($scope, userSesssion)
        }

        $scope['editDashboard'] = () => {
            $scope.$root.$broadcast(EventsNames.BEGIN_DASHBOARD_EDIT)
        }

        $scope['showDashboard'] = () => {
            const dashboards: MenuItem[] = window['MenuItems'].filter((element: MenuItem) => element.name === 'dashboard')

            if (dashboards.length > 0) {
                $state.go('dashboard', { id: dashboards[0].params['id'] })
            } else {
                const filteredMenuItems: MenuItem[] = window['MenuItems'].filter((item: MenuItem) => item.order != null).sort((menuItem1: MenuItem, menuItem2: MenuItem) =>
                    menuItem1.order - menuItem2.order
                )
                if (filteredMenuItems.length > 0) {
                    $state.go(filteredMenuItems[0].name)
                }
            }
            $scope.$root.$broadcast(EventsNames.CLOSE_DETAILS_POPUP)
        }

        $scope['checkIfDashboard'] = () => {
            return $state.current.name === 'dashboard' || $state.current.name === 'dxdashboard'
        }

        // chrome fix
        $scope.$on(EventsNames.OPENED_POPUP, () => {
            var sel = angular.element(".navbar-logo")[0]
            sel.style.display = 'none';
            sel.offsetHeight;
            sel.style.display = 'block';
        })

        $scope.$on(EventsNames.CLOSED_POPUP, () => {
            var sel = angular.element(".navbar-logo")[0]
            sel.style.display = 'none';
            sel.offsetHeight;
            sel.style.display = 'block';
        })
        // end of chrome fix

        $scope.$on(EventsNames.CHANGED_ALLOWED_DISTRIBUTORS, (event: ng.IAngularEvent, ...args: any[]) => {
            $scope.shouldRefresh = false
            $scope.$root['activeDistributors'] = args[0]
            setTimeout(() => {
                $scope.shouldRefresh = true
            }, 500)
        })
    }]
    template = TEMPLATE
    replace = true
}